import { ApiService } from 'common/services';
import { IStatisticsQueryString, AuxiliaryParams } from 'common/ui/base-filters/types';
import { parseFilters } from 'common/utils/parse-filters';

class StatisticsApiService extends ApiService {
  getAllStatistics = (filters: IStatisticsQueryString) => {
    return this.get('/api/statistics', { params: parseFilters(filters) });
  };

  getCorrelationStatistics = (filters: IStatisticsQueryString) => {
    return this.get('/api/statistics/correlation', { params: parseFilters(filters) });
  };

  getDevicesStatistics = (filters: IStatisticsQueryString) => {
    return this.get('/api/statistics/devices', { params: parseFilters(filters) });
  };

  getTopAsins = (filters: IStatisticsQueryString) => {
    return this.get('/api/statistics/top-performers', {
      params: { ...parseFilters(filters), performer_type: 'asin' },
    });
  };

  getTopCategories = (filters: IStatisticsQueryString) => {
    return this.get('/api/statistics/top-performers', {
      params: { ...parseFilters(filters), performer_type: 'category' },
    });
  };

  getTop10Pages = (filters: IStatisticsQueryString) => {
    return this.get('/api/statistics/revenue/top-charts', { params: parseFilters(filters) });
  };

  getTop10Export = (params: AuxiliaryParams) => {
    return this.get('/api/statistics/revenue/top-charts/export', { params });
  };

  getProductsStats = (filters: IStatisticsQueryString) => {
    return this.get(`/api/publishers/${filters.publisher_id}/urls/stats`, {
      params: { publisher_group: filters.publisher_group },
    });
  };

  getRecommendedAsins = (filters: IStatisticsQueryString) => {
    return this.get(`/api/affiliate/recommended-asins/${filters.publisher_id}`, { params: { limit: 0, offset: 0 } });
  };
}

export const statisticsApi = new StatisticsApiService(process.env.REACT_APP_API_URL);
